import { Card } from '@/types/learning/card';
import { slugify } from './misc';
import { ADMIN_ROUTE_PATH } from '@/administration/constants/adminRoutePaths';
import { ROUTE_PATH } from '@/constants/routePaths';

export function getLink(card: Card): string {
  const friendlyTitle = slugify(card.title);

  if (card.entity === 'learning') {
    return `${ROUTE_PATH.LEARNING_BASE}/${card.entityId}/${friendlyTitle}`;
  } else if (card.entity === 'journey') {
    return `${ROUTE_PATH.JOURNEY_BASE}/${card.entityId}/${friendlyTitle}`;
  } else if (card.entity === 'product') {
    if (card.type === 'journey') return `${ROUTE_PATH.JOURNEY_BASE}/${(card as any).journeyId}/${friendlyTitle}`;
    return `${ROUTE_PATH.COURSE_DETAILS_BASE}/${card.entityId}/${friendlyTitle}`;
  } else if (card.entity === 'collection') {
    return `${ROUTE_PATH.COLLECTION_BASE}/${card.entityId}/${friendlyTitle}`;
  }

  return '';
}

export function getEditLink(card: Card): string {
  const friendlyTitle = slugify(card.title);

  if (card.entity === 'learning') {
    // use modular courses path
    if (card.type === 'course') return `${ADMIN_ROUTE_PATH.COURSES_V2}/${card.entityId}/${slugify(card.title)}`;

    return `${ADMIN_ROUTE_PATH.CATALOG}/${card.type}/${card.entityId}`;
  } else if (card.entity === 'product') {
    return `${ADMIN_ROUTE_PATH.CATALOG}/course/${card.entityId}`;
  } else if (card.entity === 'collection') {
    return `/administration/learning-collection/${card.entityId}/${friendlyTitle}`;
  } else if (card.entity === 'journey') {
    return `${ADMIN_ROUTE_PATH.JOURNEYS}/${card.entityId}/edit`;
  }

  return '';
}
